export default __webpack_public_path__ + "static/media/portfolio-details-section.a691c38c.svg";